// extracted by mini-css-extract-plugin
export default {"cartTray":"CartTray-cartTray_S6rEq","mainWrapperCartTray":"CartTray-mainWrapperCartTray_LQcw4"};